import cn from 'classnames';
import { AnimatePresence, m } from 'motion/react';

interface MotionDivProps {
  children: React.ReactNode;
  className?: string;
  display: boolean;
}

const MotionDiv: React.FC<MotionDivProps> = ({ children, className, display = false }) => (
  <AnimatePresence>
    {display && (
      <m.div
        initial="collapsed"
        animate="open"
        exit="collapsed"
        variants={{
          open: { opacity: 1, height: 'auto' },
          collapsed: { opacity: 0, height: 0 },
        }}
        transition={{
          duration: 0.4,
          ease: [0.04, 0.62, 0.23, 0.98],
        }}
        className={cn('overflow-hidden', className)}
      >
        {children}
      </m.div>
    )}
  </AnimatePresence>
);

export default MotionDiv;
